import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Orders from "../pages/orders/page";
import Press from "../pages/press/page";
import DeployGuide from "../pages/deploy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/orders",
    element: <Orders />,
  },
  {
    path: "/press",
    element: <Press />,
  },
  {
    path: "/deploy-guide",
    element: <DeployGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
